import React, { useState } from "react";
import HrLayout from "../../layouts/HrLayout";
import Card from "../../components/UI/Card";
import AttendanceChart from "../../components/Charts/AttendanceChart";
import Button from "../../components/UI/Button";

export default function Attendance() {
  const [filterDate, setFilterDate] = useState("");
  const [deptFilter, setDeptFilter] = useState("");
  const [empSearch, setEmpSearch] = useState("");

  const attendanceList = [
    { id: 1, name: "John Doe", department: "Sales", status: "Present", timeIn: "09:15 AM" },
    { id: 2, name: "Jane Smith", department: "Marketing", status: "Absent", timeIn: "-" },
    { id: 3, name: "Alice Johnson", department: "HR", status: "On Leave", timeIn: "-" },
    { id: 4, name: "Mike Williams", department: "Tech", status: "Present", timeIn: "09:05 AM" },
  ];

  const filteredData = attendanceList.filter((emp) =>
    emp.name.toLowerCase().includes(empSearch.toLowerCase()) &&
    (deptFilter ? emp.department === deptFilter : true)
  );

  return (
    <HrLayout>
      <div className="p-6 bg-gray-100 min-h-screen">

        {/* Page Title */}
        <h1 className="text-3xl font-bold mb-6 text-gray-800">Attendance Dashboard</h1>

        {/* Top Statistics Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
          <Card className="p-5 bg-blue-50 border-l-4 border-blue-600">
            <h2 className="text-gray-600 text-sm">Present Today</h2>
            <p className="text-3xl font-bold text-blue-700">105</p>
          </Card>

          <Card className="p-5 bg-green-50 border-l-4 border-green-600">
            <h2 className="text-gray-600 text-sm">On Leave</h2>
            <p className="text-3xl font-bold text-green-700">10</p>
          </Card>

          <Card className="p-5 bg-yellow-50 border-l-4 border-yellow-600">
            <h2 className="text-gray-600 text-sm">Absent</h2>
            <p className="text-3xl font-bold text-yellow-700">5</p>
          </Card>

          <Card className="p-5 bg-purple-50 border-l-4 border-purple-600">
            <h2 className="text-gray-600 text-sm">Total Employees</h2>
            <p className="text-3xl font-bold text-purple-700">120</p>
          </Card>
        </div>

        {/* Charts Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <Card className="p-5">
            <h2 className="text-xl font-semibold mb-4">Monthly Attendance Overview</h2>
            <AttendanceChart />
          </Card>

          <Card className="p-5">
            <h2 className="text-xl font-semibold mb-4">Weekly Summary</h2>
            <ul className="text-gray-700 space-y-2">
              <li>Average Attendance: <span className="font-semibold text-blue-600">92%</span></li>
              <li>Best Day: <span className="font-semibold text-green-600">Wednesday</span></li>
              <li>Low Attendance Day: <span className="font-semibold text-red-600">Monday</span></li>
              <li>Highest Department Attendance: <span className="font-semibold text-purple-600">Tech</span></li>
            </ul>
          </Card>
        </div>

        {/* Filters */}
        <Card className="p-5 mb-6 bg-white shadow-md">
          <h2 className="text-lg font-semibold mb-4">Filters</h2>

          <div className="grid md:grid-cols-3 gap-4">
            <input
              type="date"
              className="border rounded-md p-2 shadow-sm"
              value={filterDate}
              onChange={(e) => setFilterDate(e.target.value)}
            />

            <select
              className="border rounded-md p-2 shadow-sm"
              value={deptFilter}
              onChange={(e) => setDeptFilter(e.target.value)}
            >
              <option value="">All Departments</option>
              <option value="Sales">Sales</option>
              <option value="Marketing">Marketing</option>
              <option value="HR">HR</option>
              <option value="Tech">Tech</option>
            </select>

            <input
              type="text"
              placeholder="Search employee..."
              className="border rounded-md p-2 shadow-sm"
              value={empSearch}
              onChange={(e) => setEmpSearch(e.target.value)}
            />
          </div>
        </Card>

        {/* Attendance Table */}
        <Card className="p-5 bg-white shadow-lg">
          <h2 className="text-xl font-semibold mb-4">Today's Attendance</h2>

          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-50 border-b">
                <th className="p-3 text-left">Name</th>
                <th className="p-3 text-left">Department</th>
                <th className="p-3 text-left">Status</th>
                <th className="p-3 text-left">Time In</th>
              </tr>
            </thead>

            <tbody>
              {filteredData.map((emp) => (
                <tr key={emp.id} className="border-b hover:bg-gray-100">
                  <td className="p-3 font-semibold">{emp.name}</td>
                  <td className="p-3">{emp.department}</td>

                  <td className="p-3">
                    <span
                      className={`px-3 py-1 rounded-full text-sm ${
                        emp.status === "Present"
                          ? "bg-green-100 text-green-700"
                          : emp.status === "Absent"
                          ? "bg-red-100 text-red-700"
                          : "bg-yellow-100 text-yellow-700"
                      }`}
                    >
                      {emp.status}
                    </span>
                  </td>

                  <td className="p-3">{emp.timeIn}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      </div>
    </HrLayout>
  );
}
